@if (isLoggedIn) {
  <div class="agent-view">
    <p-tabView (onChange)="onTabChange($event)">
      <!-- Whenever tabs are reordered or modified so that their indexes change,
      all references to "selectedTab" must be updated to reflect the updated
      indexes (for example, see the "Events" tab below) -->
      <p-tabPanel header="Devices/Maps" headerStyleClass="data-tab" [selected]="true">
        <devices [selected]="selectedTab == DevicesTabIndex"></devices>
      </p-tabPanel>
      <p-tabPanel header="Reports" headerStyleClass="data-tab">
        <reports></reports>
      </p-tabPanel>
      <p-tabPanel header="Events" headerStyleClass="data-tab">
        <events [agent]="agent" [selected]="selectedTab == EventsTabIndex"></events>
      </p-tabPanel>
      <p-tabPanel header="Agent Settings" headerStyleClass="config-tab">
        <agent-settings [target]="agent"></agent-settings>
      </p-tabPanel>
      <p-tabPanel header="Discoveries" headerStyleClass="config-tab">
        <discovery-list [agent]="agent"></discovery-list>
      </p-tabPanel>
      <p-tabPanel header="PRTG Export" headerStyleClass="config-tab">
        <nvtn-prtg-export-config [target]="agent"></nvtn-prtg-export-config>
      </p-tabPanel>
      <p-tabPanel header="Agent Client" headerStyleClass="config-tab">
        <agent-client [agent]="agent"></agent-client>
      </p-tabPanel>
      <p-tabPanel header="Monitors" headerStyleClass="monitor-tab">
        <monitors [selected]="selectedTab == MonitorsTabIndex"></monitors>
      </p-tabPanel>
      <p-tabPanel header="Tools" headerStyleClass="config-tab">
        <tools></tools>
      </p-tabPanel>
    </p-tabView>
    <span class="uv-save-button" >
      <button type="button" pButton
        (click)="onDump()" label="Dump Agent Config">
      </button>
      <button type="button" pButton icon="fa fa-save"
        (click)="onSave()" [disabled]="!isSaveEnabled()" label="Save Agent Changes">
      </button>
    </span>
    <p-dialog [(visible)]="showInvalidTempChangesDialog" appendTo="body">
      <p-header>
        <span>Invalid Changes</span>
      </p-header>
      <p>
        Invalid changes have been made in the following tabs and cannot be saved.
      </p>
      <ul>
        @for (tabName of tabsWithErrors; track tabName) {
          <li>{{tabName}}</li>
        }
      </ul>
      <p>
        Select one of the options below.
      </p>
      <p-footer>
        <button type="button" pButton (click)="onDiscardTempChanges()" label="Discard Changes"></button>
        <button type="button" pButton (click)="onCancelSave()" label="Cancel"></button>
      </p-footer>
    </p-dialog>
  </div>
}